import React, { useState, useEffect, useContext } from 'react';
import { loadRemoteManifest } from 'utils';
import { GlobalContext, I18NContext } from 'commons';
import customizeMoment from 'utils/momentTimezoneData';

const CMUtils = {
  initMoment: customizeMoment
};

const CriticalEvents = () => {
  const [CriticalEventsComponent, setCriticalEventsComponent] = useState();
  const globalContext = useContext(GlobalContext);
  const CMGlobalContext = { ...globalContext, CMUtils };
  const i18nContext = useContext(I18NContext);

  useEffect(() => {
    loadRemoteManifest({
      url: '/static_cm_mbr/cm-dashboard-manifest.json',
      callback: setCriticalEventsComponent,
    });
  }, []);

  if (!CriticalEventsComponent) {
    return null;
  }

  return (
    <CriticalEventsComponent {...{ globalContext: CMGlobalContext, i18nContext }} />
  );
};

export default CriticalEvents;
